import { render, staticRenderFns } from "./ContratacaoDetalhes.vue?vue&type=template&id=fb9ce20c"
import script from "./ContratacaoDetalhes.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports